export const SHOW_EXPIRATION_SESSION_BANNER = 'SHOW_EXPIRATION_SESSION_BANNER';
export const HIDE_EXPIRATION_SESSION_BANNER = 'HIDE_EXPIRATION_SESSION_BANNER';
export const SAVE_LAST_REQUEST_TIMESTAMP = 'SAVE_LAST_REQUEST_TIMESTAMP';
